var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarFill = function SvgCalendarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.8 7.46h10.8v4.86a.54.54 0 0 1-.54.54H2.34a.54.54 0 0 1-.54-.54zm8.1-4.32h2.16a.54.54 0 0 1 .54.54v2.7H1.8v-2.7a.54.54 0 0 1 .54-.54H4.5V2.06h1.08v1.08h3.24V2.06H9.9z"
  })));
};
export default SvgCalendarFill;